import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Card, CardBody, Row, Col } from "reactstrap"
import PanelHeader from "components/PanelHeader/PanelHeader.jsx"
import AgentService from "core/api/AgentService"
import ElevatorReport from "views/Forms/ElevatorReport"
import ServiceRequestReport from "views/Forms/ServiceRequestReport"

export default function CallReport() {
    const { id } = useParams()
    const [call, setCall] = useState()

    useEffect(() => {
        let ignore = false

        async function fetchData() {
            const result = await AgentService.getCall(id)
            if (!ignore) setCall(result)
        }

        fetchData()

        return () => { ignore = true }
    }, [id])

    if (call?.id === id) {
        return call.callType === "CustomerService"
            ? <ServiceRequestReport key={id} />
            : <ElevatorReport key={id} />
    }

    return (
        <>
            <PanelHeader size="sm" />
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>
                                <p>{ "Loading call report..."}</p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}